"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTypedSelector = exports.useAppDispatch = exports.store = exports.createStore = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const react_redux_1 = require("react-redux");
const baseApi_1 = require("./services/baseApi");
const createStore = (reducer = {}, options) => (0, toolkit_1.configureStore)(Object.assign({ reducer: Object.assign({ [baseApi_1.baseApi.reducerPath]: baseApi_1.baseApi.reducer, [baseApi_1.baseApiProd.reducerPath]: baseApi_1.baseApiProd.reducer }, reducer), middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi_1.baseApi.middleware, baseApi_1.baseApiProd.middleware) }, options));
exports.createStore = createStore;
exports.store = (0, exports.createStore)();
exports.useAppDispatch = react_redux_1.useDispatch;
exports.useTypedSelector = react_redux_1.useSelector;
